// i18n area 'backups' — locale lv-LV (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.lv-LV.meta.json.
import type { enUS } from './backups'

export const lvLV: typeof enUS = {
  ckpt: {
    contents: 'Pieņem',
    contentsHint:
      'Kas šeit drīkst nolaisties. „Checkpointi” ir klastera konfigurācija, „Datu rezerves kopijas” ir virtuālo mašīnu kopijas: abi lasījumi salikās kopā, viens galamērķis var pieņemt abus.',
    content: { checkpoints: 'Checkpointi', backups: 'Datu rezerves kopijas' },
    destinationsTitle: 'Dublējumu mērķi',
    checkpointsTitle: 'Checkpoint',
    restoreTitle: 'Atjaunošana',
    addDestination: 'Pievienot mērķi',
    addDestinationTitle: 'Pievienot dublējumu mērķi',
    editDestinationTitle: 'Rediģēt mērķi',
    storage: 'Storage',
    storageHint: 'Dir tipa storage (dir/NFS/CIFS/CephFS) — artefakti ir parasti faili platformas namespace ietvaros.',
    schedule: 'Grafiks',
    scheduleNone: 'Tikai manuāli',
    scheduleHourly: 'Katru stundu',
    scheduleDaily: 'Katru dienu',
    scheduleWeekly: 'Katru nedēļu',
    scheduleHour: 'Stunda',
    scheduleWeekday: 'Diena',
    scheduleHint:
      'Plānotajiem checkpoint nav operatora, kas ievadītu masterpass: keystore noslēpumi tiek iepakoti kā placeholder.',
    retention: 'Retention',
    retentionHint:
      'Cik plānoto checkpoint paturēt — sweeper noņem vecākos, kas pārsniedz šo skaitu. Manuālie un pirmsatjaunošanas checkpoint netiek noņemti nekad.',
    paused: 'Pauzēts',
    pausedHint:
      'Operatora blackout: kamēr pauze turpinās, šajā mērķī nekas netiek plānots un nekas netiek apgriezts — gan datu politikas, gan checkpoint. Notiekošās izpildes nekad netiek aiztiktas.',
    orphanRuns: '{n} bāreņu izpildes',
    orphanRunsHint:
      'Plānotas izpildes no policy, kuru šajā galamērķī vairs nav: neviena retention tās nepārvalda — nekad neskaitītas, nekad neapgrieztas — un tikai roka tās dzēš. tvirt diagnose lēca „backups“ nosauc noņemtās policy.',
    rescan: 'Atkārtoti pieņemt artefaktus',
    rescanTitle: '{name} artefaktu atkārtota pieņemšana',
    rescanHint:
      'Atjauno rezerves kopiju katalogu (VM/CT/App) no galamērķī esošo artefaktu manifestiem. Esošās rindas nekad netiek aiztiktas; nezināmu politiku kopijas paliek bāreņi (nekad netiek automātiski izgrieztas). Solis pēc bootstrap atjaunošanas.',
    masterpassDrWarning:
      'Katastrofas scenārijs: LUKS diski atgriežas TIKAI no checkpoint AR masterpass. Plānotie checkpoint iepako vietturus — periodiski veiciet manuālu checkpoint ar masterpass.',
    policy: {
      title: 'Datu backup politikas',
      hint: 'Nosauktas politikas: kuri objekti (kind, tagi, scope), cik bieži, kad izpilde drīkst sākties un cik kopiju paturēt. Iesaistīšanas žests paliek objekta īpašniekam: tagus piešķir viņa paša scope.',
      add: 'Pievienot politiku',
      column: 'Datu politikas',
      name: 'Nosaukums',
      nameHint:
        'Policy etiķete, unikāla galamērķa ietvaros. Izpildes seko policy stabilajam id: pārdēvēšana ir bez maksas; dzēšana padara tās izpildes par bāreņiem (vairs netiek skaitītas ne apgrieztas).',
      kindLocked: 'Esošas policy objektu saimi nevar mainīt: izveidojiet jaunu policy.',
      kindLabel: 'Objekti',
      kind: { vm: 'Virtuālās mašīnas', ct: 'Konteineri', app: 'Lietotnes' },
      tags: 'Tagu atlasītājs',
      tagsHint:
        'Pāri tag=vērtība, atdalīti ar komatiem, saistīti ar AND. Tukši tagi un scope neatlasa neko — nekad „visu”.',
      scopes: 'Scope',
      scopesHint: 'Scope ceļi (apakškoki), atdalīti ar komatiem, savā starpā saistīti ar OR.',
      windowStart: 'Logs no',
      windowEnd: 'Logs līdz',
      windowHint:
        'Izpildes logs (HH:MM, vietējais laiks; sākums aiz beigām pārkāpj pusnakti). Tas pārvalda tikai STARTU: izpilde, kas to pārsniedz, nekad netiek nogalināta.',
      mode: 'Režīms',
      modeHint: 'Inkrementālais jāj uz sēriju saimes; pārtrūkusi sērija degradējas par full, pateikts žurnālā.',
      modeFull: 'Full',
      modeIncremental: 'Inkrementāls',
      requireQuiesce: 'Pieprasīt quiesce (guest agent)',
      paused: 'Politika pauzēta',
      retentionNone: 'Paturēt visu',
      retentionCount: 'Skaits',
      retentionGfs: 'GFS gredzeni',
      gfs: { keepLast: 'Pēdējās', daily: 'Dienas', weekly: 'Nedēļas', monthly: 'Mēneša', yearly: 'Gada' },
      gfsHint:
        'Katram gredzenam patur jaunāko kopiju no katra no pēdējiem N periodiem. Paturēta kopija uztur dzīvu visu savu ķēdi — nekad bāzi ar bāreņiem.',
      lastRun: 'Pēdējā izpilde',
      neverRan: 'nekad nav izpildīts'
    },
    lastCheckpoint: 'Pēdējais checkpoint',
    neverRun: 'Nekad nav izveidots',
    createNow: 'Izveidot checkpoint',
    createNowTitle: 'Izveidot checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Aizsargā keystore noslēpumu vērtības (argon2id → AES-256-GCM, katrai vērtībai atsevišķi). Tā nekad netiek saglabāta: uzglabājiet to — bez tās atjaunošana īsto noslēpumu vietā atdod placeholder.',
    masterpassEmptyHint: 'Atstājiet tukšu, lai noslēpumu vietā iepakotu skaidrus placeholder.',
    createStarted: 'Checkpoint norisinās…',
    destinationInUseError: "'{name}' vēl satur checkpoint — vispirms izdzēsiet tos.",
    origin: 'Izcelsme',
    originManual: 'manuāls',
    originSchedule: 'plānots',
    originPreRestore: 'pirms atjaunošanas',
    originPreChange: 'pirms izmaiņas',
    preChangeRetention: 'Checkpointi pirms izmaiņas',
    preChangeRetentionHint:
      'Tukšs = izslēgts. Pirmais konfigurācijas ieraksts pēc klusuma perioda šeit iesaldē iepriekšējo stāvokli (izcelsme „pirms izmaiņas“); jaunākie tiek glabāti līdz skaitam — sava, apgriežama retencija.',
    diffTitle: 'Izmaiņu priekšskatījums',
    diffFailed: 'Priekšskatījums neizdevās',
    diffRetry: 'Mēģināt vēlreiz',
    diffCounts: '{changed} mainīsies · {missing} tiks izveidoti · {extra} lieki · {equal} identiski',
    diffChanged: 'mainās',
    diffMissing: 'tiktu izveidots',
    diffExtra: 'tiktu dzēsts',
    diffJsonb: 'jsonb atsauces nav pārbaudāmas pirms piemērošanas',
    diffSecret: 'aizzīmogoti lauki, nesalīdzināmi',
    diffMore: 'vēl {n}…',
    diffNeeded: 'Palaišana aktivizējas, kad priekšskatījums atspoguļo izvēli.',
    phase: 'Stāvoklis',
    phaseRunning: 'norisinās',
    phaseComplete: 'pabeigts',
    phaseError: 'kļūda',
    secrets: 'Noslēpumi',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholder',
    size: 'Izmērs',
    created: 'Izveidots',
    destination: 'Mērķis',
    download: 'Lejupielādēt .tvbk',
    deleteCheckpoint: 'Dzēst checkpoint',
    noCheckpoints: 'Nav neviena checkpoint — izveidojiet to no kāda mērķa.',

    // Round #156 (standarta dialogs): backup ieraksta pilnā lasīšanas virsma —
    // detaļu rindas laukiem, kas tabulā nekad netika rādīti.
    families: 'Saimes',
    generation: 'Paaudze',
    completedAt: 'Pabeigts',
    errorDetail: 'Kļūdas detaļas',
    manifest: 'Manifest',
    restoreHint:
      'Augšupielādējiet .tvbk artefaktu: explorer parāda, ko tas satur, pēc tam izvēlieties, ko un kā atjaunot.',
    uploadFile: 'Augšupielādēt .tvbk failu',
    uploading: 'Notiek augšupielāde…',
    uploadFailed: 'Neizdevās atvērt artefaktu',
    explorerTitle: 'Checkpoint saturs',
    checkpointFrom: 'Klastera {cluster} checkpoint, izveidots {when} ({origin}, paaudze {generation})',
    otherCluster:
      'Šis checkpoint ir no CITA klastera ({cluster}) — atjaunošana starp klasteriem nāks kādā nākamajā raundā.',
    encrypted: 'šifrēts',
    objectsCount: '{n} objekti',
    mode: 'Režīms',
    modeMerge: 'Merge — saskaņo: atlasīto rindu upsert, nekas netiek dzēsts',
    modeOverwrite:
      'Overwrite — uzvar checkpoint: pilnībā atlasīta saime tiek aizstāta veselumā (pašreizējās rindas, kuru checkpoint nav, tiek dzēstas)',
    restoreMasterpassHint:
      'Masterpass, ar kuru tika izveidots šis checkpoint. Bez tās šifrētie noslēpumi tiek atjaunoti kā skaidri placeholder.',
    checkMasterpass: 'Pārbaudīt',
    masterpassOk: 'Masterpass ir pareiza',
    masterpassWrong: 'Nepareiza masterpass',
    parachuteDestination: 'Izpletņa mērķis',
    parachuteHint: 'Pirms pieskarties jebkurai rindai, task šeit izveido automātisku pirmsatjaunošanas checkpoint.',
    summaryTitle: 'Kas notiks',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'visa saime',
    summaryObjects: '{n} atlasīti objekti',
    confirmHint:
      'Ievadiet klastera nosaukumu ({name}), lai apstiprinātu — atjaunošana pārraksta deklarēto konfigurāciju.',
    confirmField: 'Klastera nosaukums',
    startRestore: 'Atjaunot',
    restoreRunning: 'Atjaunošana norisinās…',
    restoreDone: 'Atjaunošana pabeigta — reconciler konverģē uz jauno deklarāciju.',
    restoreFailed: 'Atjaunošana neizdevās',
    discard: 'Atmest',
    selectionEmpty: 'Atlasiet vismaz vienu saimi vai objektu.'
  },

  backup: {
    intro: {
      title: 'VM un konteineru datu backup',
      subtitle: 'Būvbloki, ko izmanto ārējā backup programmatūra',
      whatItIs:
        'TVirt piedāvā četrus primitīvus: quiesced snapshot, change tracking katram diskam, tikai lasāmu NBD eksportu un konfigurācijas eksportu. Tos vada Veeam, Bacula, Acronis un līdzīgie.',
      whatItIsNot:
        'TVirt nav backup produkts: tas neko neplāno, nepiemēro retention un neglabā nekādu jūsu datu arhīvu. Retention, katalogi un atjaunošanas politikas paliek programmatūrai, ko jau izmantojat.'
    },
    cbt: {
      title: 'Izmaiņu izsekošana',
      colVm: 'VM',
      colDisk: 'Disks',
      colState: 'Stāvoklis',
      colBitmaps: 'Bitkartes',
      colObservedAt: 'Novērots',
      colChangeId: 'Change ID',
      colMechanic: 'Mehānisms',
      stateActive: 'Aktīva',
      stateInactive: 'Izslēgta',
      stateInconsistent: 'Nekonsekventa — nākamajai kopijai jābūt pilnai',
      stateBroken: 'Ķēde pārtraukta — atspējojiet, tad iespējojiet kā jaunu ķēdi',
      stateSnapshots: 'Vienmēr ieslēgta — delta starp momentuzņēmumiem',
      stateUnavailable: 'Šajā diskā nav pieejama',
      mechanic: {
        'qcow2-bitmap': 'qcow2 bitkarte',
        'rbd-snapdiff': 'Ceph momentuzņēmumu diff',
        'lvm-thin-delta': 'Thin pool delta',
        none: 'Nav'
      },
      empty:
        'Nav VM disku. Izsekošanu lasa pa diskiem: iespējojiet to qcow2 diskā vai veidojiet momentuzņēmumus rbd/SAN.',
      chainBroken: 'Ķēde pārtraukta',
      chainBrokenText:
        'Pārtrauca {reason}: {bitmaps}. Atspējojiet bitkarti (ķēde ir zaudēta, nākamā kopija ir pilna), tad iespējojiet to kā jaunu ķēdi.',
      lineages: 'Ēras',
      epochFrozen: 'iesaldēta momentuzņēmumā {snapshot}',
      epochLost: 'zaudēta ({cause})',
      epochRecording: 'ieraksta galvā',
      milestones: 'Atskaites punkti (momentuzņēmumi)',
      enable: 'Iespējot izsekošanu',
      disable: 'Atspējot',
      reset: 'Atiestatīt',
      changedAreas: 'Mainītie apgabali',
      denied: 'Jums nav atļaujas šajā VM',
      enableTitle: 'Iespējot izmaiņu izsekošanu',
      disableTitle: 'Atspējot izmaiņu izsekošanu',
      resetTitle: 'Atiestatīt bitkarti',
      areasTitle: 'Mainītie apgabali',
      bitmapName: 'Bitkartes nosaukums',
      bitmapNameHint: 'Savs nosaukums: tvirt- un tvbk- pieder platformai',
      granularity: 'Granularitāte (baiti)',
      granularityHint: 'Divnieka pakāpe; noklusējums 65536',
      bitmap: 'Bitkarte',
      disableHint: 'Noņem bitkarti un visu tās ēru vēsturi: nākamajai kopijai jābūt pilnai.',
      resetHint: 'Iztukšo bitkarti — jauns pamats: change ID, kas vecāks par atiestatīšanu, vairs nav salikams.',
      areasFrom: 'No momentuzņēmuma',
      areasTo: 'Līdz momentuzņēmumam',
      areasRun: 'Aprēķināt',
      areasResult: '{count} mainīti apgabali, {bytes}',
      areasEmpty: 'Starp abiem momentuzņēmumiem nav mainītu apgabalu',
      areasZero: 'nulles',
      areasMore: 'rādīti pirmie {shown} no {count}',
      submit: 'Apstiprināt',
      error: 'Izsekošanas darbība neizdevās'
    },
    exports: {
      title: 'Atvērtie NBD eksporti',
      colVm: 'VM',
      colDisk: 'Disks',
      colSnapshot: 'Momentuzņēmums',
      colBitmap: 'Bitkarte',
      colPhase: 'Fāze',
      colNode: 'Mezgls',
      colEndpoint: 'Galapunkts',
      colExpires: 'Beidzas',
      colCreated: 'Atvērts',
      colError: 'Kļūda',
      phase: {
        preparing: 'Sagatavo',
        ready: 'Gatavs',
        closed: 'Aizvērts',
        error: 'Neizdevās'
      },
      expiresIn: 'pēc {minutes} min',
      expired: 'beidzies',
      empty: 'Nav eksportu. Lasīšanas sesija pasniedz vienu disku vienā momentuzņēmumā NBD klientam; rakstīšanas sesija piepilda apturētas VM neskartu disku. Abas beidzas, kad notek termiņš.',
      endpointHint: 'TLS ar klastera CA; eksporta nosaukums ir biļete — tā mirst kopā ar sesiju',
      closeDenied: 'Jums nav atļaujas aizvērt šīs VM eksportus',
      open: 'Atvērt NBD eksportu',
      openTitle: 'Atvērt NBD eksportu',
      openDisk: 'Disks',
      openBitmap: 'Bitkarte (neobligāti)',
      openBitmapHint:
        'Publicē šīs bitkartes šajā momentuzņēmumā iesaldēto ēru kā mainīto extent meta-context (tikai qcow2 diski)',
      openTtl: 'Darbības laiks (minūtes)',
      openSubmit: 'Atvērt',
      openError: 'Eksportu neizdevās atvērt',
      colMode: 'Režīms',
      mode: {
        read: 'Lasīšana',
        write: 'Rakstīšana'
      },
      caCertificate: 'Klastera CA',
      caCopy: 'Kopēt PEM',
      caDownload: 'Lejupielādēt ca-cert.pem',
      caHint: 'Ierakstiet PEM failā ca-cert.pem privātā mapē un pieslēdzieties ar nbds://…?tls-certificates=<mape> (nbdcopy, nbdinfo) vai --object tls-creds-x509,dir=<mape>,endpoint=client (qemu-img)',
      caAbsent: 'Sesija nenes CA (nav PKI)',
      openWrite: 'Atvērt rakstīšanas eksportu',
      openWriteTitle: 'Atvērt rakstīšanas eksportu',
      openWriteIntro: 'Diskam jābūt neskartam: dzimis tukšs, nekad nerakstīts, bez momentuzņēmuma; VM apturēta. Atjaunošana PIEPILDA disku, nevis to labo. Kamēr sesija ir atvērta, VM nevar startēt, uzņemt momentuzņēmumu, klonēties, un disku nevar pārvietot.',
      openWriteSubmit: 'Atvērt',
      openWriteError: 'Rakstīšanas eksportu neizdevās atvērt',
      openWriteDenied: 'Jums trūkst vm.restore.data šajā VM',
      openWriteStopped: 'Apturiet VM, lai atvērtu rakstīšanas eksportu',
      fromDescription: 'Izveidot VM no apraksta',
      fromDescriptionTitle: 'Izveidot VM no apraksta',
      fromDescriptionIntro: 'export-vm-meta apraksts atgriežas kā apturēta VM ar tukšiem aprakstītās ģeometrijas diskiem — gatava rakstīšanas eksportiem, disku pēc diska. Baiti šeit neiet cauri: tos nes restore-disk (CLI) vai dublēšanas produkta NBD klients.',
      fromDescriptionDoc: 'Apraksts (JSON)',
      fromDescriptionDocHint: 'Ielīmējiet export-vm-meta dokumentu vai izvēlieties failu',
      fromDescriptionFile: 'Izvēlēties failu…',
      fromDescriptionInvalid: 'Teksts nav JSON dokuments',
      fromDescriptionName: 'Jaunās VM nosaukums',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Jūsu sākuma scope',
      fromDescriptionStorage: 'Disku krātuve',
      fromDescriptionStorageHint: 'Katrs disks dzimst šeit, krātuves noklusējuma formātā',
      fromDescriptionMetadataStorage: 'Metadatu krātuve',
      fromDescriptionSameAsStorage: 'Tā pati, kas diskiem',
      fromDescriptionBridge: 'Tilts',
      fromDescriptionBridgeHint: 'Bez tilta vai tīkla VM dzimst bez tīkla kartēm',
      fromDescriptionNetwork: 'Loģiskais tīkls (fabric/tīkls)',
      fromDescriptionSubmit: 'Izveidot',
      fromDescriptionError: 'VM neizdevās izveidot',
      fromDescriptionDone: 'VM izveidota: {name}',
      fromDescriptionOpen: 'Atvērt VM',
      fromDescriptionDenied: 'Jums trūkst vm.create',
      fromDescriptionStillRunning: 'Izveide vēl notiek: gaidām tālāk'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'VM datu rezerves kopijas',
      titleOnVm: 'Datu rezerves kopijas',
      empty:
        'Nav kopiju. Kopija pārnes diskus, UEFI varstore un vTPM stāvokli uz galamērķi un pārdzīvo virtuālo mašīnu.',
      colVm: 'VM',
      colCreated: 'Izveidota',
      colPhase: 'Iznākums',
      colDestination: 'Galamērķis',
      colContains: 'Saturs',
      colSize: 'Izmērs',
      colOrigin: 'Izcelsme',
      colMode: 'Veids',
      retentionChip: 'Glabāšana',
      retentionHint:
        'Galamērķa glabāšanas noteikums var izdzēst šo kopiju nejautājot: tā dzimusi no grafika. Manuālās kopijas nekad netiek slaucītas.',
      policyRemoved: 'Policy noņemta: {name}',
      policyRemovedHint:
        'Policy, kas ieplānoja šo backup, vairs nepastāv: neviena retention to nepārvalda (nekad netiek apgriezts automātiski) — dzēsiet to manuāli, kad tas vairs nav vajadzīgs.',
      phase: {
        running: 'Notiek',
        complete: 'Pabeigta',
        error: 'Neizdevās'
      },
      origin: {
        manual: 'Manuāla',
        schedule: 'Plānota'
      },
      mode: {
        full: 'Pilna',
        incremental: 'Pieauguma'
      },
      contains: {
        disks: 'Diski',
        varstore: 'UEFI varstore',
        vtpm: 'vTPM stāvoklis',
        snapshots: 'Momentuzņēmumi'
      },
      vmState: {
        stopped: 'VM izslēgta',
        running: 'VM darbojas (karsts)'
      },
      artifactClass: { metadata: 'Metadati', data: 'Dati', secret: 'Noslēpums' },
      detail: {
        tabOverview: 'Pārskats',
        tabArtefact: 'Artefakts',
        id: 'Identifikators',
        scope: 'Tvērums',
        vmState: 'VM stāvoklis kopēšanas brīdī',
        pointInTime: 'Datu mirklis',
        completedAt: 'Pabeigta',
        node: 'Mezgls, kas kopēja',
        error: 'Kļūda',
        path: 'Mape krātuvē',
        checksum: 'manifesta sha256',
        secretsExposed: 'Sensitīvs materiāls atklātā veidā',
        secretsExposedYes: 'Jā — galamērķis nešifrē',
        secretsExposedNo: 'Nē',
        baseBackup: 'Bāzes kopija',
        tabManifest: 'Manifests',
        manifestHint:
          'Artefakta atklātais rādītājs: viens fails rindā ar savu sha256. Mapi var pārbaudīt arī bez TVirt — pietiek ar qemu-img, tar un jq.',
        manifestEmpty: 'Manifests neuzskaita failus.',
        manifestError: 'Manifestu nevar nolasīt',
        colEntry: 'Fails',
        colClass: 'Klase',
        colSha: 'sha256'
      },
      create: {
        action: 'Kopēt tagad',
        title: 'Kopēt tagad',
        submit: 'Sākt kopēšanu',
        destination: 'Galamērķis',
        destinationHint: 'Tikai galamērķi, kas pieņem kopijas.',
        noDestinations: 'Neviens galamērķis nepieņem kopijas: izveidojiet to sadaļā Sistēma → Checkpoints.',
        contentsHint:
          'Ceļo visi diski, UEFI varstore un vTPM stāvoklis. Pēdējie divi ir būtība: aizzīmogotam viesim jāstartē no jauna.',
        error: 'Kopēšana nesākās',
        stillRunning: 'Kopēšana vēl notiek — tā turpinās, arī ja aizverat.',
        vmRunning:
          'Mašīna ir {phase}: dublēšanai vajadzīga stabila VM — izslēgta aukstajai kopijai, strādājoša karstajai.'
      },
      restore: {
        action: 'Atjaunot',
        title: 'Atjaunot',
        intro: 'Atjaunošana ir neatgriezeniska. Izvēlieties, kur dati atgriežas: jaunā mašīnā vai virsū sākotnējai.',
        modeNewVm: 'Atjaunot JAUNĀ VM',
        modeNewVmHint:
          'Neaiztiek neko, kas pastāv — ar šo iespēju kopiju pārbauda. Jauns identifikators un tikko kalti MAC adreses.',
        modeOver: 'Pārrakstīt sākotnējo VM',
        modeOverHint: 'Iznīcina mērķa VM pašreizējos datus, bez ceļa atpakaļ. Mašīnai jābūt izslēgtai.',
        newName: 'Jaunās VM nosaukums',
        newNameHint: 'Tam jābūt brīvam mērķa tvērumā.',
        storage: 'Krātuve diskiem',
        storageHint: 'Obligāti: manifests pieraksta diska izmēru un formātu, nekad krātuvi, kurā tas atradās.',
        metadataStorage: 'Krātuve varstore un vTPM',
        metadataStorageHint: 'Kur nolaižas UEFI identitāte un vTPM stāvoklis.',
        sameAsStorage: 'Tā pati, kas diskiem',
        bridge: 'Resursdatora bridge',
        bridgeHint:
          'Katra pierakstītā tīkla karte atgriežas uz šī bridge ar jaunu MAC. Atstāts tukšs — VM piedzimst bez kartēm, un tas ir drošāks noklusējums.',
        overwriteTitle: 'Jūs gatavojaties pārrakstīt šo VM',
        overwriteName: 'Nosaukums',
        overwriteId: 'Identifikators',
        overwriteDisks: 'Diski, kas tiks pārrakstīti',
        overwriteNoDisks: 'Nav disku.',
        overwriteKeeps:
          'Neskarti paliek identifikators, nosaukums, tvērums, tīkla kartes un MAC adreses: kopija ir DATI, konfigurācija ir checkpoint.',
        confirmField: 'VM nosaukums',
        confirmHint: 'Ierakstiet {name}, lai apstiprinātu.',
        targetLoading: 'Nolasa mērķa VM…',
        targetRunning: 'Mērķa VM ir {phase}: atjaunošana pārraksta baitus zem viesa, tāpēc prasa to izslēgtu.',
        targetGone: 'Sākotnējo VM vairs nevar nolasīt: paliek atjaunošana jaunā VM.',
        onlyComplete: 'Kopija ir {phase}: atjaunot var tikai pabeigta kopija.',
        submitNewVm: 'Atjaunot jaunajā VM',
        submitOver: 'Pārrakstīt',
        error: 'Atjaunošana nesākās',
        stillRunning: 'Atjaunošana vēl notiek — veselu disku kopēšana prasa laiku.'
      }
    },
    guest: {
      title: {
        ct: 'Konteineru datu dublējumi',
        app: 'App datu dublējumi'
      },
      tabTitle: 'Dublējumi',
      empty: 'Nav dublējumu. Dublējums pārnes pastāvīgos datus uz galamērķi un pārdzīvo savu objektu.',
      colSubject: {
        ct: 'Konteiners',
        app: 'App'
      },
      colCreated: 'Izveidots',
      colPhase: 'Iznākums',
      colDestination: 'Galamērķis',
      colContains: 'Saturs',
      colSize: 'Izmērs',
      colOrigin: 'Izcelsme',
      policyRemoved: 'Policy noņemta: {name}',
      policyRemovedHint:
        'Policy, kas ieplānoja šo backup, vairs nepastāv: neviena retention to nepārvalda (nekad netiek apgriezts automātiski) — dzēsiet to manuāli, kad tas vairs nav vajadzīgs.',
      phase: {
        running: 'Notiek',
        complete: 'Pabeigts',
        error: 'Neizdevās'
      },
      origin: {
        manual: 'Manuāls',
        schedule: 'Plānots'
      },
      state: {
        stopped: 'Objekts apturēts',
        running: 'Objekts darbojas (iesaldēts)'
      },
      contains: {
        rootfs: 'Rootfs koks',
        config: 'Konfigurācija',
        volumes: 'Pastāvīgie sējumi',
        root: 'Pastāvīgais root'
      },
      artifactClass: {
        metadata: 'Metadati',
        data: 'Dati',
        secret: 'Noslēpums'
      },
      create: {
        action: 'Dublēt tagad',
        title: 'Jauns dublējums',
        submit: 'Sākt dublējumu',
        error: 'Dublējums nesākās',
        destination: 'Galamērķis',
        destinationHint: 'Tikai galamērķi, kas pieņem datu dublējumus.',
        noDestinations: 'Neviens galamērķis nepieņem datu dublējumus: pievienojiet galamērķim “Datu dublējumi”.',
        hint: {
          ct: 'Ceļo viss rootfs koks, uzticami (skaitliskie īpašnieki, xattr, ACL), plus deklarētā konfigurācija manifestā. Darbojošos konteineru IESALDĒ uz visu pakošanas laiku: crash-consistent kopija, deklarēta.',
          app: 'Ceļo TIKAI pastāvīgie sējumi (un pastāvīgais root), plus konfigurācija manifestā. Efemērais ir izslēgts ar ratifikāciju, un manifests to nosauc; par slepenām deklarētās env vērtības neceļo.'
        },
        stillRunning: 'Dublējums vēl notiek — veselu koku pakošana prasa laiku.'
      },
      detail: {
        tabOverview: 'Pārskats',
        tabManifest: 'Manifests',
        id: 'Identifikators',
        scope: 'Tvērums',
        state: 'Stāvoklis kopēšanas brīdī',
        pointInTime: 'Dati brīdī',
        completedAt: 'Noslēgts',
        node: 'Mezgls, kas kopēja',
        error: 'Kļūda',
        path: 'Mape krātuvē',
        checksum: 'Manifesta sha256',
        manifestHint:
          'Artefakta rādītājs: viens ieraksts failam ar tā sha256 — bez jaucējiem “dublējums ir” ir ticības akts.',
        manifestError: 'Manifestu nevar nolasīt',
        manifestEmpty: 'Manifestā nav artefaktu.',
        colEntry: 'Fails',
        colClass: 'Klase',
        colSha: 'sha256',
        excluded: 'Izslēgts ar ratifikāciju (neceļo)',
        secretKeys: 'Izlaistās slepenās env atslēgas (#307) — pēc atjaunošanas ievadiet vēlreiz'
      },
      restore: {
        action: 'Atjaunot',
        title: 'Atjaunošana',
        submit: 'Atjaunot',
        error: 'Atjaunošana nesākās',
        stillRunning: 'Atjaunošana vēl notiek — veselu koku izpakošana prasa laiku.',
        onlyComplete: 'Dublējums ir {phase}: atjaunot var tikai pabeigts dublējums.',
        asNew: {
          ct: 'JAUNĀ konteinerā — neko neiznīcina: žests, ar kuru dublējumu pārbauda',
          app: 'JAUNĀ App — neko neiznīcina: žests, ar kuru dublējumu pārbauda'
        },
        over: {
          ct: 'PĀRI avota konteineram — tiek aizstāts viss rootfs koks',
          app: 'PĀRI avota App — tiek aizstāts katra pastāvīgā sējuma saturs'
        },
        name: 'Jaunā objekta nosaukums',
        storage: 'Krātuve',
        storageHint: 'Kur nolaižas atjaunotie dati — manifests nekad nereģistrē zaudēto pool.',
        storageDeclared: 'Manifestā deklarētās krātuves',
        bridge: 'Resursdatora tilts',
        bridgeHint:
          'Katra reģistrētā karte atgriežas uz šī tilta ar svaigu MAC. Tukšs = piedzimst nepieslēgts, drošākais noklusējums.',
        node: 'Mezgls',
        nodeHint: 'Loceklis, uz kura App atdzimst: mezgls ir klastera identitāte un nekad nenāk no manifesta.',
        secretKeysWarning:
          'Par slepenām deklarētās env vērtības dublējumā neceļo: atdzimusī kopija tās grib ievadītas no jauna (task žurnāls nosauc atslēgas).',
        overInventory: 'Jūs gatavojaties pārrakstīt šo objektu',
        confirmType: 'Apstiprināšanai ierakstiet {name}',
        targetGone: 'Avota objektu vairs nevar nolasīt: paliek atjaunošana kā jaunam.',
        targetLoading: 'Lasa mērķa objektu…',
        targetRunning: 'Mērķa objekts darbojas: atjaunošana aizstāj baitus zem viesa un grib to apturētu.'
      }
    }
  }
}
